import React from "react";

//#region src/icons/SearchIcon.tsx
function SearchIcon({ size = 20, color = "currentColor" }) {
	return /* @__PURE__ */ React.createElement("svg", {
		width: size,
		height: size,
		className: "DocSearch-Search-Icon",
		viewBox: "0 0 24 24",
		"aria-hidden": "true"
	}, /* @__PURE__ */ React.createElement("circle", {
		cx: "11",
		cy: "11",
		r: "8",
		stroke: color,
		fill: "none",
		strokeWidth: "1.4"
	}), /* @__PURE__ */ React.createElement("path", {
		d: "m21 21-4.3-4.3",
		stroke: color,
		fill: "none",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}));
}

//#endregion
export { SearchIcon as t };
//# sourceMappingURL=SearchIcon-DbxRKLtx.js.map